<template>
    <v-card style="background-color: #E1F1E1">
        <v-card-title class="headline">{{ title }}</v-card-title>

        <div id="labelsDiv"> </div>

        <v-card-text></v-card-text>

        <img :src="showBarChart ? require('@/assets/barchart.png') : require('@/assets/linechart.png')" id="chart_type"
            class="linechart" style="border: solid red 0px;" @click="toggleBarChart" />

        <div style="margin:0;padding:0;height:30px;border: 0px solid red;">
            <div id="zoom_message" style="display:none;width:400px;margin:10px;background-color:#E1F1E1;">You can select an
                area of the graph to zoom into more detail.</div>
            <div id="no_data_message" style="display:none;width:400px;margin:10px;background-color: #E1F1E1;">No data found.
                Check your filters and date range.</div>
        </div>

        <div ref="graphdiv" id="graphdiv" class="graph" style="width:80%;height:580px;"></div>

        <img id="export_image" style="display: none;" />
        <a id="export_image_link" style="display: none;">&nbsp;</a>

        <v-progress-circular v-if="waiting" top
            :style="{ position: 'absolute', left: '50%', top: '50%', transform: 'translateX(-50%);translateY(-50%);' }"
            :size="70" :width="7" color="purple" indeterminate></v-progress-circular>

    </v-card>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import Dygraph from 'dygraphs';
import { DateTime } from "luxon";

import RGBColor from 'rgbcolor';

const DEFAULT_ATTRS = {

    backgroundColor: 'transparent',

    // Texts displayed below the chart's x-axis and to the left of the y-axis
    titleFont: 'bold 18px serif',
    titleFontColor: 'black',

    // Texts displayed below the chart's x-axis and to the left of the y-axis
    axisLabelFont: 'bold 14px serif',
    axisLabelFontColor: 'black',

    // Texts for the axis ticks
    labelFont: 'normal 12px serif',
    labelFontColor: 'black',

    // Text for the chart legend
    legendFont: 'bold 12px serif',
    legendFontColor: 'black',

    // Default position for vertical labels
    vLabelLeft: 20,

    legendHeight: 20,    // Height of the legend area
    legendMargin: 20,
    lineHeight: 30,
    maxlabelsWidth: 0,
    labelTopMargin: 35,
    magicNumbertop: 8,
};

@Component({
    components: {},
})
export default class VueDygraph extends Vue {

    public $refs!: {
        graphElement: HTMLElement;
    };

    @Prop({ type: String, default: 'Values' }) public title!: string;
    @Prop({ type: String, default: 'Time' }) public xlabel!: string;
    @Prop({ type: String, default: 'Values' }) public ylabel!: string;

    /**
     * Draws the text contained in 'divLabel' at the specified position.
     */

    private defaultPlotter = Dygraph.Plotters.linePlotter;

    private plotter = Dygraph.Plotters.linePlotter;

    private waiting: boolean = false;
    private showBarChart = false;
    private graphOptions = {};
    private graph: any;
    private graphData = [[0, 0]];

    // [
    //                 //     [ new Date("2009/07/12"), 100, 200 ],
    //                 //     [ new Date("2009/07/19"), 150, 220 ]
    //                 // ],
    //                 // {
    //                 //     labels: [ "x", "A", "B" ]
    //                 // });

    public updateOptions(options: object) {
        // console.debug(this.graphData[0].length)
        // Merge data and options
        const obj = Object.assign({}, this.graphOptions, options);
        this.graph.updateOptions(obj);
    }

    // Exports a dygraph object as a PNG image.
    // dygraph: A Dygraph object
    // img: An IMG DOM node
    // userOptions: An object with the user specified options.
    public exportAsPNG() {

        const options = {
            backgroundColor: 'white',
        };

        const img: any = document.getElementById('export_image');

        const canvas = this.asCanvas(options);

        if (img !== null) {
            img.src = canvas.toDataURL();

            const href = img.src.replace('image/png', 'image/octet-stream');

            const link: any = document.getElementById('export_image_link');
            link.download = 'ddd.png';
            link.href = href;
            link.click();
        }
    }

    // public updateGraph() {
    //   // console.debug(this.graphData[0].length);
    //   // Merge data and options
    //   const obj = Object.assign({}, this.graphOptions, {file: this.graphData});
    //   this.$data._graph.updateOptions(obj);
    // }

    // @Watch('graphData')
    // protected onGraphDataChanged(newDate: any, oldDate: any): any {

    // }

    public setWaiting(waiting: boolean) {
        this.waiting = waiting;
    }

    public setData(labels: string[], data: any) {
        this.graphData = data;
        this.graph.updateOptions({ labels: labels, file: this.graphData });
    }

    public setYLabel(label: string) {
        this.ylabel = label;
        this.graph.updateOptions({ ylabel: label, file: this.graphData });
    }

    public resetZoom() {
        this.graph.resetZoom();
    }

    public clear() {
        this.graph.updateOptions({ labels: ['', ''], file: [[0, 0]] });
    }

    private putText(ctx: any, left: number, top: number, divLabel: any, font: string, color: string) {

        const textAlign = divLabel.style.textAlign || 'left';
        const text = divLabel.innerText || divLabel.textContent;

        ctx.fillStyle = color;
        ctx.font = font;
        ctx.textAlign = textAlign;
        ctx.textBaseline = 'middle';
        ctx.fillText(text, left, top);
    }

    private hack_update(self: any, o: any) {
        if (typeof (o) !== 'undefined' && o !== null) {
            for (const k in o) {
                if (o.hasOwnProperty(k)) {
                    self[k] = o[k];
                }
            }
        }
        return self;
    }

    //
    //  Exports a dygraph into a single canvas object.
    //
    //  Returns a canvas object that can be exported as a PNG.
    //
    //  dygraph: A Dygraph object
    //  userOptions: An object with the user specified options.
    //
    //
    private asCanvas(userOptions: any) {

        const options: any = {};
        // const canvas = Dygraph.createCanvas();
        const canvas = document.createElement('canvas');

        this.hack_update(options, DEFAULT_ATTRS);
        this.hack_update(options, userOptions);

        canvas.width = this.graph.width_;
        canvas.height = this.graph.height_ + options.legendHeight;

        this.drawPlot(canvas, options);
        this.drawLegend(canvas, options);

        return canvas;
    }

    //
    //  Tests whether the browser supports the canvas API and its methods for
    //  drawing text and exporting it as a data URL.
    //
    private isSupported() {

        try {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            return (!!canvas.toDataURL && context && !!context.fillText);
        } catch (e) {
            // Silent exception.
        }
        return false;
    }

    // Adds the plot and the axes to a canvas context.
    private drawPlot(canvas: any, options: any) {

        const ctx = canvas.getContext('2d');

        // Add user defined background
        ctx.fillStyle = options.backgroundColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Copy the plot canvas into the context of the new image.
        const plotCanvas = this.graph.hidden_;

        let i = 0;

        ctx.drawImage(plotCanvas, 0, 0);

        // Add the x and y axes
        const axesPluginDict = this.getPlugin('Axes Plugin');
        if (axesPluginDict) {
            const axesPlugin = axesPluginDict.plugin;

            for (i = 0; i < axesPlugin.ylabels_.length; i++) {
                this.putLabel(ctx, axesPlugin.ylabels_[i], options,
                    options.labelFont, options.labelFontColor);
            }

            for (i = 0; i < axesPlugin.xlabels_.length; i++) {
                this.putLabel(ctx, axesPlugin.xlabels_[i], options,
                    options.labelFont, options.labelFontColor);
            }
        }

        // Title and axis labels
        const labelsPluginDict = this.getPlugin('ChartLabels Plugin');
        if (labelsPluginDict) {
            const labelsPlugin = labelsPluginDict.plugin;

            this.putLabel(ctx, labelsPlugin.title_div_, options,
                options.titleFont, options.titleFontColor);

            this.putLabel(ctx, labelsPlugin.xlabel_div_, options,
                options.axisLabelFont, options.axisLabelFontColor);

            this.putVerticalLabelY1(ctx, labelsPlugin.ylabel_div_, options,
                options.axisLabelFont, options.axisLabelFontColor, 'center');

            this.putVerticalLabelY2(ctx, labelsPlugin.y2label_div_, options,
                options.axisLabelFont, options.axisLabelFontColor, 'center');
        }


        for (i = 0; i < this.graph.layout_.annotations.length; i++) {
            this.putLabel(ctx, this.graph.layout_.annotations[i], options,
                options.labelFont, options.labelColor);
        }

    }

    // Draws a label (axis label or graph title) at the same position
    // where the div containing the text is located.
    private putLabel(ctx: any, divLabel: any, options: any, font: string, color: string) {

        if (!divLabel || !divLabel.style) {
            return;
        }

        let top = parseInt(divLabel.style.top, 10);
        let left = parseInt(divLabel.style.left, 10);

        if (!divLabel.style.top.length) {
            const bottom = parseInt(divLabel.style.bottom, 10);
            const height = parseInt(divLabel.style.height, 10);

            top = ctx.canvas.height - options.legendHeight - bottom - height;
        }

        // FIXME: Remove this 'magic' number needed to get the line-height.
        top = top + options.magicNumbertop;

        const width = parseInt(divLabel.style.width, 10);

        switch (divLabel.style.textAlign) {
            case 'center':
                left = left + Math.ceil(width / 2);
                break;
            case 'right':
                left = left + width;
                break;
        }

        this.putText(ctx, left, top, divLabel, font, color);
    }

    // Draws a label Y1 rotated 90 degrees counterclockwise.
    private putVerticalLabelY1(ctx: any, divLabel: any, options: any, font: string, color: string, textAlign: any) {

        if (!divLabel) {
            return;
        }

        let top = parseInt(divLabel.style.top, 10);
        let left = parseInt(divLabel.style.left, 10) + parseInt(divLabel.style.width, 10) / 2;
        const text = divLabel.innerText || divLabel.textContent;

        // FIXME: The value of the 'left' property is frequently 0, used the option.
        if (!left) {
            left = options.vLabelLeft;
        }

        if (textAlign === 'center') {
            const textDim = ctx.measureText(text);
            top = Math.ceil((ctx.canvas.height - textDim.width) / 2 + textDim.width);
        }

        ctx.save();
        ctx.translate(0, ctx.canvas.height);
        ctx.rotate(-Math.PI / 2);

        ctx.fillStyle = color;
        ctx.font = font;
        ctx.textAlign = textAlign;
        ctx.fillText(text, top, left);

        ctx.restore();
    }

    // Draws a label Y2 rotated 90 degrees clockwise.
    private putVerticalLabelY2(ctx: any, divLabel: any, options: any, font: string, color: string, textAlign: any) {

        if (!divLabel) {
            return;
        }

        let top = parseInt(divLabel.style.top, 10);
        const right = parseInt(divLabel.style.right, 10) + parseInt(divLabel.style.width, 10) * 2;
        const text = divLabel.innerText || divLabel.textContent;

        if (textAlign === 'center') {
            top = Math.ceil(ctx.canvas.height / 2);
        }

        ctx.save();
        ctx.translate(parseInt(divLabel.style.width, 10), 0);
        ctx.rotate(Math.PI / 2);

        ctx.fillStyle = color;
        ctx.font = font;
        ctx.textAlign = textAlign;
        ctx.fillText(text, top, right - ctx.canvas.width);

        ctx.restore();
    }

    // Draws the legend of a dygraph
    private drawLegend(canvas: any, options: any) {

        const ctx = canvas.getContext('2d');

        // Margin from the plot
        const labelTopMargin = 10;

        // Margin between labels
        const labelMargin = 5;

        const colors = this.graph.getColors();
        // Drop the first element, which is the label for the time dimension
        const labels = this.graph.attr_('labels').slice(1);

        // 1. Compute the width of the labels:
        let labelsWidth = 0;

        let i;
        for (i = 0; i < labels.length; i++) {
            labelsWidth = labelsWidth + ctx.measureText('- ' + labels[i]).width + labelMargin;
        }

        let labelsX = Math.floor((canvas.width - labelsWidth) / 2);
        const labelsY = canvas.height - options.legendHeight + labelTopMargin;


        const labelVisibility = this.graph.attr_('visibility');

        ctx.font = options.legendFont;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';

        let usedColorCount = 0;
        for (i = 0; i < labels.length; i++) {
            if (labelVisibility[i]) {
                // TODO Replace the minus sign by a proper dash, although there is a
                //     problem when the page encoding is different than the encoding
                //     of this file (UTF-8).
                const txt = '- ' + labels[i];
                ctx.fillStyle = colors[usedColorCount];
                usedColorCount++;
                ctx.fillText(txt, labelsX, labelsY);
                labelsX = labelsX + ctx.measureText(txt).width + labelMargin;
            }
        }
    }

    //   Finds a plugin by the value returned by its toString method..
    //   Returns the the dictionary corresponding to the plugin for the argument.
    //   If the plugin is not found, it returns null.
    private getPlugin(name: string) {
        for (const p of this.graph.plugins_) {
            if (p.toString() === name) {
                return p;
            }
        }
        return null;
    }

    private barChartPlotter = (e: any) => {
        // We need to handle all the series simultaneously.
        if (e.seriesIndex !== 0) {
            return;
        }

        const g = e.dygraph;
        const ctx = e.drawingContext;
        const sets = e.allSeriesPoints;
        const y_bottom = e.dygraph.toDomYCoord(0);

        // Find the minimum separation between x-values.
        // This determines the bar width.
        let min_sep = Infinity;
        for (const points of sets) {
            for (let i = 1; i < points.length; i++) {
                const sep = points[i].canvasx - points[i - 1].canvasx;
                if (sep < min_sep) {
                    min_sep = sep;
                }
            }
        }
        const bar_width = Math.ceil((2.0 / 3) * min_sep);

        const fillColors: string[] = [];
        const strokeColors: string[] = g.getColors();

        for (const c of strokeColors) {
            const color = new RGBColor(c);
            color.r = Math.floor((255 + color.r) / 2);
            color.g = Math.floor((255 + color.g) / 2);
            color.b = Math.floor((255 + color.b) / 2);
            fillColors.push(color.toRGB());
        }

        const alternate = [];

        // preallocate alternative array of -1 and 1 for speed when drawing below
        for (let i = 0; i < 50; i++) {
            alternate.push(Math.pow(-1, i));
        }

        for (let j = 0; j < sets.length; j++) {
            ctx.fillStyle = fillColors[j];
            ctx.strokeStyle = strokeColors[j];
            for (const p of sets[j]) {
                const center_x = p.canvasx;

                let plot_offset = 0;
                const real_bar_width = bar_width / sets.length;

                const k = Math.floor(j / 2.0);
                plot_offset = (alternate[j] * (2 * (k + 1) - 1)) / 2.0;

                const x_left = center_x - plot_offset * real_bar_width;

                ctx.fillRect(
                    x_left,
                    p.canvasy,
                    real_bar_width,
                    y_bottom - p.canvasy,
                );

                ctx.strokeRect(
                    x_left,
                    p.canvasy,
                    real_bar_width,
                    y_bottom - p.canvasy,
                );
            }
        }
    }

    // 'graphOptions': {
    //   handler (val, oldVal) {
    //     console.debug('graphOptions update, was waiting : ', this.waitingForUpdate)
    //     if (this.waitingForUpdate) {
    //       this.updateGraph()
    //       this.waitingForUpdate = false
    //     } else {
    //       this.$data._graph.updateOptions(val)
    //     }
    //   },

    // public getOption(name: string, opt_seriesName: string):  ;

    // }

    private toggleBarChart() {
        this.showBarChart = !this.showBarChart;

        if (this.showBarChart) {
            this.plotter = this.barChartPlotter;
        } else {
            this.plotter = this.defaultPlotter;
        }

        this.updateOptions({ plotter: this.plotter });
    }

    private zoomCallback(minDate: number, maxDate: number, yRanges: []) {
        const self = this;

        if (this.graph == null) {
            return;
        }

        if (this.graph.isZoomed('x') === false && this.graph.isZoomed('y') === false) {
            // This is true when the user has double clicked the graph to cancel zoom
            self.$emit('resetZoom');
            return;
        } else if (this.graph.isZoomed('x') === true) {
            const detailStartDateTm = DateTime.fromSeconds(Math.trunc(minDate) / 1000);
            const detailEndDateTm = DateTime.fromSeconds(Math.trunc(maxDate) / 1000);

            self.$emit('zoom', detailStartDateTm, detailEndDateTm);
        }
        // else if (this.graph.isZoomed('y') === true) {

        // }
    }

    private created() {
        this.plotter = this.defaultPlotter;
    }

    private mounted() {
        const self = this;

        const div = document.getElementById('graphdiv');

        this.graphOptions = {
            zoomCallback: this.zoomCallback,
            title: '',
            // linear_regression_large_gaps: json.linear_regression_large_gaps,
            // linear_regression_real_sensor_points: json.linear_regression_real_sensor_points,
            xlabel: self.xlabel,
            ylabel: self.ylabel,
            // labelsDivWidth: 350,
            digitsAfterDecimal: 4,
            maxNumberWidth: 10,
            includeZero: true,
            drawPoints: true,
            strokeWidth: 4,
            labelsShowZeroValues: true,
            showRoller: false,

            // highlightSeriesOpts: {
            //           strokeWidth: 3,
            //           strokeBorderWidth: 1,
            //           highlightCircleSize: 5,
            //         },

            labelsDiv: 'labelsDiv',
            labelsSeparateLines: true,
            // labelsDivWidth: 550,

            connectSeparatedPoints: true,
            // drawCallback: function(graph) {
            //   $('#graph_loading').hide();
            // },
            axes: {
                x: null,
            },
            plotter: self.plotter,
            // highlightSeriesOpts: json.graph_options['highlightSeriesOpts'],
        };

        this.graph = new Dygraph(div, this.graphData, this.graphOptions);

        // this.graphOptions.clickCallback = this.clickCallback;
        // this.graphOptions.drawCallback = this.drawCallback;
        // this.graphOptions.highlightCallback = this.highlightCallback;
        // this.graphOptions.pointClickCallback = this.pointClickCallback;
        // this.graphOptions.underlayCallback = this.underlayCallback;
        // this.graphOptions.unhighlightCallback = this.unhighlightCallback;
        // this.graphOptions.zoomCallback = this.zoomCallback;
        // this.graphOptions.drawHighlightPointCallback = this.drawHighlightPointCallback;
        // this.graphOptions.drawPointCallback = this.drawPointCallback;
        // this.graphOptions.interactionModel = this.interactionModel;
    }
}

</script>

<style lang="css">
/**
 * Default styles for the dygraphs charting library.
 */

.dygraph-legend {
    position: absolute;
    left: 70px !important;
    font-size: 14px;
    z-index: 10;
    width: 250px;
    /* labelsDivWidth */
    /*
  dygraphs determines these based on the presence of chart labels.
  It might make more sense to create a wrapper div around the chart proper.
  top: 0px;
  right: 2px;
  */
    background: white;
    line-height: normal;
    text-align: left;
    overflow: hidden;
}

/* styles for a solid line in the legend */
.dygraph-legend-line {
    display: inline-block;
    position: relative;
    bottom: .5ex;
    padding-left: 1em;
    height: 1px;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    /* border-bottom-color is set based on the series color */
}

/* styles for a dashed line in the legend, e.g. when strokePattern is set */
.dygraph-legend-dash {
    display: inline-block;
    position: relative;
    bottom: .5ex;
    height: 1px;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    /* border-bottom-color is set based on the series color */
    /* margin-right is set based on the stroke pattern */
    /* padding-left is set based on the stroke pattern */
}

.dygraph-roller {
    position: absolute;
    z-index: 10;
}

/* This class is shared by all annotations, including those with icons */
.dygraph-annotation {
    position: absolute;
    z-index: 10;
    overflow: hidden;
}

/* This class only applies to annotations without icons */
/* Old class name: .dygraphDefaultAnnotation */
.dygraph-default-annotation {
    border: 1px solid black;
    background-color: white;
    text-align: center;
}

.dygraph-axis-label {
    /* position: absolute; */
    /* font-size: 14px; */
    z-index: 10;
    line-height: normal;
    overflow: hidden;
    color: black;
    /* replaces old axisLabelColor option */
}

.dygraph-axis-label-x {}

.dygraph-axis-label-y {}

.dygraph-axis-label-y2 {}

.dygraph-title {
    font-weight: bold;
    z-index: 10;
    text-align: center;
    /* font-size: based on titleHeight option */
}

.dygraph-xlabel {
    text-align: center;
    /* font-size: based on xLabelHeight option */
}

/* For y-axis label */
.dygraph-label-rotate-left {
    text-align: center;
    /* See http://caniuse.com/#feat=transforms2d */
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
}

/* For y2-axis label */
.dygraph-label-rotate-right {
    text-align: center;
    /* See http://caniuse.com/#feat=transforms2d */
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
}
</style>